var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBzd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3639)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#0168B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2402_3639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2402_3639)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V3.83333H23V0H0Z",
    fill: "#E93C43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.1665V22.9998H23V19.1665H0Z",
    fill: "#E93C43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.25C9.11827 17.25 7.1875 14.6756 7.1875 11.5C7.1875 8.32436 9.11827 5.75 11.5 5.75C13.8817 5.75 15.8125 8.32436 15.8125 11.5C15.8125 14.6756 13.8817 17.25 11.5 17.25Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46875 11.4998C6.46875 15.2047 8.72132 18.2082 11.5 18.2082C14.2787 18.2082 16.5312 15.2047 16.5312 11.4998C16.5312 7.79493 14.2787 4.7915 11.5 4.7915C8.72132 4.7915 6.46875 7.79493 6.46875 11.4998ZM15.8125 11.4998C15.8125 14.6755 13.8817 17.2498 11.5 17.2498C9.11827 17.2498 7.1875 14.6755 7.1875 11.4998C7.1875 8.3242 9.11827 5.74984 11.5 5.74984C13.8817 5.74984 15.8125 8.3242 15.8125 11.4998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1875 11.5C7.1875 14.6756 9.11827 17.25 11.5 17.25C13.8817 17.25 15.8125 14.6756 15.8125 11.5C15.8125 8.32436 13.8817 5.75 11.5 5.75C9.11827 5.75 7.1875 8.32436 7.1875 11.5ZM14.8062 11.5C14.8062 13.9347 13.326 15.9083 11.5 15.9083C9.67401 15.9083 8.19375 13.9347 8.19375 11.5C8.19375 9.06534 9.67401 7.09167 11.5 7.09167C13.326 7.09167 14.8062 9.06534 14.8062 11.5Z",
    fill: "#5B8C39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34375 13.4163L11.4562 13.0566L13.6562 13.4163V14.3746L11.4562 14.015L9.34375 14.3746V13.4163Z",
    fill: "#5B8C39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0624 9.58301H12.9374C12.9374 9.58301 13.1407 15.333 11.4999 15.333C9.85917 15.333 10.0624 9.58301 10.0624 9.58301Z",
    fill: "#769DF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 9.58301,
    width: 1.4375,
    height: 1.91667,
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 10.0625,
    y: 9.58301,
    width: 1.4375,
    height: 1.91667,
    fill: "#F6F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 10.0625,
    y: 7.6665,
    width: 2.875,
    height: 1.91667,
    rx: 0.5,
    fill: "#5B8C39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91882 12.2664C10.3158 12.2664 10.6376 11.4083 10.6376 10.3498C10.6376 9.29123 10.3158 8.43311 9.91882 8.43311C9.52187 8.43311 9.20007 9.29123 9.20007 10.3498C9.20007 11.4083 9.52187 12.2664 9.91882 12.2664Z",
    fill: "#E9AD35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0812 12.2664C13.4781 12.2664 13.7999 11.4083 13.7999 10.3498C13.7999 9.29123 13.4781 8.43311 13.0812 8.43311C12.6842 8.43311 12.3624 9.29123 12.3624 10.3498C12.3624 11.4083 12.6842 12.2664 13.0812 12.2664Z",
    fill: "#5C2216"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3639)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3639",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBzd);
export default __webpack_public_path__ + "static/media/BZD.c7f33ecbbfc2b5b8ae2c75e82ca55c05.svg";
export { ForwardRef as ReactComponent };